<template>
  <div>
    <FundList :fundDataUrl="'/arbitrage'"></FundList>
  </div>
</template>

<script>
import FundList from "@/components/fund/base/FundList.vue";

export default {
  components: {
    FundList,
  },
};
</script>